import React, { useState } from 'react';
import styles from './PriceCalculation.module.scss';
import ProductBasedCalculation from './ProductBasedCalculation';
import SimpleCalculator from './SimpleCalculator';

const SUB_TABS = {
  productBased: 'productBased',
  calculator: 'calculator',
};

export default function CalculatorTab({ onError }) {
  const [activeSubTab, setActiveSubTab] = useState(SUB_TABS.productBased);

  return (
    <>
      <div className={styles.subTabs}>
        <button
          type="button"
          className={`${styles.subTab} ${
            activeSubTab === SUB_TABS.productBased ? styles.active : ''
          }`}
          onClick={() => setActiveSubTab(SUB_TABS.productBased)}
        >
          Product-based calculation
        </button>
        <button
          type="button"
          className={`${styles.subTab} ${
            activeSubTab === SUB_TABS.calculator ? styles.active : ''
          }`}
          onClick={() => setActiveSubTab(SUB_TABS.calculator)}
        >
          Calculator
        </button>
      </div>

      {activeSubTab === SUB_TABS.productBased && (
        <ProductBasedCalculation onError={onError} />
      )}
      {activeSubTab === SUB_TABS.calculator && (
        <SimpleCalculator onError={onError} />
      )}
    </>
  );
}
